// extracted by mini-css-extract-plugin
export var avatarBone = "_b-4";
export var buttonBone = "_b-3";
export var continueBone = "_b-a";
export var frame = "_b-1";
export var logoBone = "_b-2";
export var pickerGrid = "_b-d";
export var pitchBone = "_b-9";
export var productBone = "_b-8";
export var sectionBone = "_b-7";
export var shell = "_b-0";
export var skeletonPulse = "_b-b";
export var subtitleBone = "_b-6";
export var titleBone = "_b-5";
export var viewport = "_b-c";